/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowtexttitle3Inputs */

const en_aiflowtexttitle3 = /** @type {(inputs: Aiflowtexttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the title`)
};

const de_aiflowtexttitle3 = /** @type {(inputs: Aiflowtexttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur den Titel`)
};

/**
* | output |
* | --- |
* | "Only the title" |
*
* @param {Aiflowtexttitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowtexttitle3 = /** @type {((inputs?: Aiflowtexttitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowtexttitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowtexttitle3(inputs)
	return de_aiflowtexttitle3(inputs)
});
export { aiflowtexttitle3 as "aiFlowTextTitle" }